import * as React from "react";
import { Viewport, ViewSmall, ViewLarge } from "bernie-view";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import ViewWhereToStayGuideButton from "./components/ViewWhereToStayGuideButton";
import { NeighborhoodCard } from "./components/NeighborhoodCard";
import { DestinationNeighborhoodsProps } from "./typings";
import { Neighborhood } from "typings/microserviceModels/te-neighborhood-flex-module";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkHeading, UitkText } from "uitk-react-text";

const DestinationNeighborhoods = (props: DestinationNeighborhoodsProps) => {
  const { flexComponent, context } = props;
  const { model } = flexComponent;
  const { content } = model;
  const { formatText } = useLocalization();

  if (!content?.items?.length) {
    return null;
  }

  const { items, whereToStayUrl } = content;
  const neighborhoods = items.slice(0, 6);

  const neighborhoodsKeyHelper: ItemKeyHelper = new ItemKeyHelper("popular-neighborhood");

  const neighborhoodCards = (isDesktop: boolean) =>
    neighborhoods.map((neighborhood: Neighborhood, neighborhoodIndex: number) => (
      <NeighborhoodCard
        key={neighborhoodsKeyHelper.next()}
        className="all-b-margin-three"
        neighborhood={neighborhood}
        position={neighborhoodIndex + 1}
        context={context}
        isDesktop={isDesktop}
        showFavorite={true}
        isClickeable={true}
        view={model.view}
      />
    ));

  return (
    <div
      className="DestinationNeighborhoods all-y-padding-six uitk-cell all-cell-1-1"
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      <UitkHeading level={3} size={600}>
        {context.searchContext.location.type === "neighborhood" ? (
          <UitkText>
            {formatText("destinationNeighborhood.neighborhood.title", context.searchContext.location.parent.name)}
          </UitkText>
        ) : (
          <UitkText>{formatText("destinationNeighborhood.title", context.searchContext.location.name)}</UitkText>
        )}
      </UitkHeading>

      <Viewport>
        <ViewSmall>
          <div className="destinationNeighborhoodsContainer all-t-margin-four">{neighborhoodCards(false)}</div>
        </ViewSmall>

        <ViewLarge>
          <div className="destinationNeighborhoodsContainer uitk-grid all-cell-1-3 all-x-gutter-three all-t-margin-four">
            {neighborhoodCards(true)}
          </div>
        </ViewLarge>
      </Viewport>

      {Boolean(whereToStayUrl) && <ViewWhereToStayGuideButton href={whereToStayUrl} />}
    </div>
  );
};

export default DestinationNeighborhoods;
